import AreaServiceSelect from './AreaServiceSelect.vue';
import areaServiceMixin from './mixin';

export { areaServiceMixin };
export default AreaServiceSelect;
